import classNames from 'classnames';
import React, { JSX } from 'react';
import { Asset } from './types';
import { useAssetStatusStyles } from '../styles/asset-status-styles';

const STATUS_STRING = {
  Approved: _TL_('Approved'),
  ApprovedLimited: _TL_('Approved limited'),
  Rejected: _TL_('Rejected'),
  Pending: _TL_('Pending'),
};

export function useGetStyledAssetStatus(i18n: any) {
  const styles = useAssetStatusStyles();
  return (asset: Asset): JSX.Element => (
    <p className={classNames('asset-status', asset.EditorialStatus === 'Rejected' && styles.rejected)}>
      {i18n.getString(STATUS_STRING[asset.EditorialStatus])}
    </p>
  );
}
